import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { ReportLogService } from "src/app/services/report-log.service";
import { TravelerService } from "src/app/services/traveler.service";
import { UtilityService } from "src/app/services/utility.service";

@Component({
  selector: "app-report-log-deleted-layover-hotels",
  templateUrl: "./report-log-deleted-layover-hotels.component.html",
  styleUrls: ["./report-log-deleted-layover-hotels.component.css"],
})
export class ReportLogDeletedLayoverHotelsComponent implements OnInit {
  model: any = {};
  yearList: any = [];
  tripOptionList = [];
  alltripList = [];
  years = "";
  tripId = "";
  searchText = "";

  public displayedColumns = [
    // 'updatedOnDisplay',
    "formattedDate",
    "formattedTime",
    "updatedByName",
    "tripCode",
    "ppeWhsCode",
    "salesmanCode",
    "customerNumber",
    "companyName",
    "groups",
    "legalName",
    "gender",
    "nickName",
    "dateofBirthDisplay",
    "cellPhone",
    "emailAddress",
    "hotelName",
    "hotelConfirmation",
    "lhCost",
    "lhCheckInDateDisplay",
    "lhCheckOutDateDisplay",
    "lhRoomType",
    "layoverJourneyType",
  ];

  public dataSource =
    new MatTableDataSource<DeletedTravelerLayoverHotelEntity>();
  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;
  @ViewChild(MatSort, { static: true })
  sort: MatSort;
  response: any = {};
  constructor(
    private travelerService: TravelerService,
    public _utilityService: UtilityService,
    private reportLogService: ReportLogService
  ) {}

  ngOnInit() {
    this.yearList = this._utilityService.fillYear(
      new Date().getFullYear() - 3,
      new Date().getFullYear() + 1
    );
    this.travelerService.getTripCodeList().subscribe((result) => {
      this.alltripList = result;
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  deletedTravelerLayoverHotelList() {
    this.dataSource.data = [];
    if (+this.tripId > 0 && +this.years > 0) {
      this.reportLogService
        .getTravelerLayoverHotelDetailDeletedList(this.years, this.tripId)
        .subscribe((result) => {
          this.model = this.dataSource.data =
            result as DeletedTravelerLayoverHotelEntity[];
          this.dataSource.paginator = this.paginator;
        });
    }
  }

  changeYear() {
    this.tripId = "";
    this.tripOptionList = [];
    if (this.alltripList && this.alltripList.length > 0)
      this.tripOptionList = this.alltripList.filter(
        (t) => t.years === this.years
      );
    this.dataSource.data = [];
  }

  changeTrip() {
    this.deletedTravelerLayoverHotelList();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.searchText = filterValue;
    this.dataSource.filter = filterValue;
  }
}

export interface DeletedTravelerLayoverHotelEntity {
  id: number;
  updatedOnDisplay: string;
  updatedByName: string;
  tripCode: string;
  ppeWhsCode: string;
  salesmanCode: string;
  customerNumber: string;
  companyName: string;
  groups: number;
  legalName: string;
  gender: number;
  nickName: string;
  dateofBirthDisplay: string;
  cellPhone: string;
  emailAddress: string;
  hotelName: string;
  hotelConfirmation: string;
  lhCost: number;
  lhCheckInDateDisplay: string;
  lhCheckOutDateDisplay: string;
  lhRoomType: string;
  layoverJourneyType: string;
  formattedDate: string;
  formattedTime: string;
}
